var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColdSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "272.000000pt",
    height: "282.000000pt",
    viewBox: "0 0 272.000000 282.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,282.000000) scale(0.100000,-0.100000)",
    fill: "#C0BFC7",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540 2275 l0 -125 55 0 55 0 0 -104 0 -104 -89 -4 c-100 -5 -138 -23 -182 -86 l-24 -36 -3 -663 c-2 -650 -2 -664 18 -703 11 -22 39 -52 62 -67 l42 -28 758 -3 c742 -2 759 -2 797 18 50 25 87 73 100 130 6 25 11 161 11 303 l0 257 105 0 105 0 0 80 0 80 -165 0 -165 0 0 -351 c0 -209 -4 -358 -10 -369 -5 -10 -24 -23 -41 -29 -43 -15 -1413 -15 -1456 -1 -17 6 -35 22 -42 36 -8 18 -11 203 -11 645 l0 620 25 24 c23 24 28 25 175 25 l150 0 0 165 0 165 175 0 175 0 0 -165 0 -165 410 0 c492 0 450 14 450 -147 l0 -103 165 0 165 0 0 80 0 80 -104 0 -104 0 -7 43 c-9 58 -47 112 -98 139 -41 22 -51 23 -379 26 l-338 3 0 104 0 104 58 3 57 3 3 123 3 122 -451 0 -450 0 0 -125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 905 l0 -315 660 0 660 0 0 315 0 315 -660 0 -660 0 0 -315z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdSystem);
export default __webpack_public_path__ + "static/media/ColdSystem.6536f5fb9140cc6256f48adf89e663d4.svg";
export { ForwardRef as ReactComponent };